import React, { useEffect } from "react";
import { X } from "lucide-react";
import { adminDialogPanel, adminIconBtn, adminOverlay } from "@/components/admin/adminUi";

export default function AdminDialog({
  open,
  onClose,
  title,
  children,
  footer,
  maxWidth = "max-w-3xl",
  z = "z-[70]",
  testId,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className={adminOverlay(z)} data-testid={testId}>
      <button type="button" aria-label="Close dialog" className="absolute inset-0" onClick={onClose} />
      <div className={`relative flex flex-col ${adminDialogPanel(maxWidth)}`} onClick={(e) => e.stopPropagation()}>
        {title != null && (
          <div className="admin-sticky-bar flex items-center justify-between gap-3 p-5 border-b sticky top-0 z-10">
            <h2 className="text-lg font-['Unbounded'] font-bold text-white min-w-0 truncate">{title}</h2>
            <button type="button" aria-label="Close" onClick={onClose} className={adminIconBtn}>
              <X className="w-5 h-5" />
            </button>
          </div>
        )}
        <div className="flex-1 min-h-0 overflow-y-auto p-5">{children}</div>
        {footer && (
          <div className="admin-sticky-bar sticky bottom-0 border-t p-4 pb-[max(1rem,env(safe-area-inset-bottom))]">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
